/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1AccessRequestState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ACCESS_REQUEST_STATE_ENTITY_NAME = 'ixm.userauth.v1.AccessRequest';
export const ixmUserauthV1AccessRequestStateEntity = new schema.Entity<IxmUserauthV1AccessRequestState>(IXM_USERAUTH_V1_ACCESS_REQUEST_STATE_ENTITY_NAME, {}, { idAttribute: 'accessRequestId' });

